var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.BootFunctions = OCS.BootFunctions || {};
OCS.Functions.get_domain = function () {
    var domain = OCS.domain;
    if (!OCS.domain) {
        domain = document.domain;
        domain = domain.split('.');
        domain = domain.shift();
        if (domain && domain.length) {
            console.log(domain);
            //domain = domain.join('.');
        } else {
            domain = "";
        }
    }
    return domain;
};
OCS.Functions.run_boot_functions = function (type) {
    if (OCS.BootFunctions[type]) {
        var boot_functions = OCS.BootFunctions[type];
        Object.each(boot_functions, function (method, name) {
            if (typeof method === 'function') {
                setTimeout(method, 0); // Start the method on a new process
            }
        });
    }
};
